export const ToastSeverityMap = {
    error: "error",
    warning: "warning",
    success: "success"
}